(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/team-email.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/team-email.js');
'use strict';

const Checkbox = svs.ui.reactForm.Checkbox;
const {
  TextField
} = svs.arena.pages.teams.components;
const {
  handleSendEmailAsync
} = svs.arena.pages.teams.helpers;
const TeamEmail = _ref => {
  let {
    teamId,
    activeMembers,
    inactiveMembers,
    onHide = () => {}
  } = _ref;
  const [isIncludeInactive, setIsIncludeInactive] = React.useState(true);
  const handleSubmit = async message => {
    const track = {
      category: 'spela-tillsammans',
      action: 'all_members_email',
      opt_label: 'send_email'
    };
    svs.components.analytics.trackEvent(track);
    const sendList = activeMembers.filter(m => m.isCurrentMember === false).map(m => m.customerId);
    if (isIncludeInactive) {
      inactiveMembers.forEach(m => {
        sendList.push(m.customerId);
      });
    }
    const res = await handleSendEmailAsync(teamId, sendList, message);
    if (!(res !== null && res !== void 0 && res.error)) {
      onHide();
    }
  };
  const handleClick = e => {
    e.stopPropagation();
    const track = {
      category: 'spela-tillsammans',
      action: 'all_members_email',
      opt_label: isIncludeInactive ? 'only_active_members' : 'include_resting_members'
    };
    svs.components.analytics.trackEvent(track);
    setIsIncludeInactive(!isIncludeInactive);
  };
  const onCancel = () => {
    const track = {
      category: 'spela-tillsammans',
      action: 'all_members_email',
      opt_label: 'cancel_email'
    };
    svs.components.analytics.trackEvent(track);
    onHide();
  };
  return React.createElement(React.Fragment, null, React.createElement(Checkbox, {
    checked: isIncludeInactive,
    className: "margin-top-1",
    onChange: handleClick
  }, "Inkludera vilande medlemmar"), React.createElement(TextField, {
    onCancel: onCancel,
    onHide: onHide,
    onSubmit: handleSubmit
  }));
};
svs.arena.pages.teams.components.TeamEmail = TeamEmail;

 })(window);